export const initQuerySelectionValues = (variables) => {
    return {
        type: 'INIT_QUERY_SELECTION_VALUES',
        payload: variables
    }
}
export const setQueryValues = (code, values) => {
    return {
        type: 'SET_QUERY_VALUES',
        payload: {
            values,
            code
        }
    }
}
export const setQueryAllValues = (code) => {
    return {
        type: 'SET_QUERY_ALL_VALUES',
        payload: code
    }
}

export const setSelectionLang = (lang) =>{
    return{
        type: 'SET_SELECTION_LANG',
        payload: lang
    }
}

export const setSelectionFile = (file) =>{
    return{
        type: 'SET_SELECTION_FILE',
        payload: file
    }
}

export const setStubHeadingFromMetaData = (stub, heading) =>{
    return {
        type: 'SET_STUB_HEADING_FROM_METADATA',
        payload: {stub,heading}
    }
}